import { getBoldedWords } from "@/utils/helpers";
import style from "./OrderedList.module.css";

type OrderedListProps = {
  /** Wrap words or word with ** to make them bold */
  items: string[];
};

export const OrderedList = ({ items }: OrderedListProps) => {
  return (
    <ol className={style["ordered-list"]}>
      {items.map((item, idx) => (
        <li className={style["ordered-item"]} key={idx}>
          {getBoldedWords(item).map((part, partIdx) => (
            <span key={partIdx}>
              {typeof part === "string" ? (
                part
              ) : (
                <strong>{part.bold}</strong>
              )}{" "}
            </span>
          ))}
        </li>
      ))}
    </ol>
  );
};
